import { useContext } from "react"
import { HistoricoFechamentosContext } from "./HistoricoFechamentosContext"

export function useHistoricoFechamentosContext() {
    return useContext(HistoricoFechamentosContext)
}
